module.exports = __webpack_public_path__ + "img/5f7d158.png";